import { render } from "./ApplicationMark.vue?vue&type=template&id=f4e7b6ba"
const script = {}
script.render = render

export default script